import { GGCoinError } from "@developerz.ai/ggcoin-sdk";

/** Translate an SDK error into a user-readable line for the dashboard. */
export function describeError(err: unknown): string {
  if (err instanceof GGCoinError) {
    switch (err.code) {
      case "INVALID_CREDENTIALS":
        return "That email, password, or TOTP code didn't check out.";
      case "TOTP_NOT_ENROLLED":
        return "Finish your 2FA setup before signing in.";
      case "UNAUTHENTICATED":
        return "Your session expired. Please sign in again.";
      case "VALIDATION_ERROR":
        return "Some fields didn't pass validation — check the form and try again.";
      case "API_KEY_NOT_FOUND":
        return "That API key no longer exists.";
      case "WEBHOOK_ENDPOINT_NOT_FOUND":
        return "That webhook endpoint no longer exists.";
      case "UNSAFE_WEBHOOK_URL":
        return "That webhook URL is not allowed (must be a public HTTPS host).";
      case "NETWORK_ERROR":
        return "Network problem — check your connection and try again.";
      default:
        return err.message || `Request failed (${err.code}).`;
    }
  }
  if (err instanceof Error) return err.message;
  return "Something went wrong.";
}
